export const v4Number = value => {
  if (
    !["string", "number"].includes(typeof value) ||
    (typeof value === "string" && !value.trim())
  )
    return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const v4Money = value => {
  const number = v4Number(value);
  return number === null
    ? "—"
    : number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const v4Quantity = value => {
  const number = v4Number(value);
  return number === null
    ? "—"
    : number.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
};

export const v4Date = value => {
  if (!value) return "—";
  const date = new Date(
    /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value
  );
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString("pt-BR", {
        timeZone: "America/Sao_Paulo",
        ...(String(value).length === 10
          ? { dateStyle: "short" }
          : { dateStyle: "short", timeStyle: "short" })
      });
};

export const v4AlternativeLabel = (item, index) =>
  ({
    maintain_catalog: "Preços atuais",
    v3_registered: "Sugestão V3",
    v3_deterministic: "V3 pelas regras",
    anchor_lower5: "Referência 5% menor",
    anchor_higher5: "Referência 5% maior"
  }[item.candidate_id] ||
  (typeof item.label === "string" && item.label) ||
  `Alternativa ${index + 1}`);

export const v4VolumeCondition = item => {
  const percent = v4Number(item.required_change_pct);
  if (percent === null) return "Sem condição de volume disponível";
  if (item.direction === "same_volume")
    return "Preserva a contribuição com o mesmo volume";
  if (["increase", "increase_required"].includes(item.direction))
    return `Precisa de ${v4Quantity(
      Math.abs(percent)
    )}% a mais de volume para compensar`;
  if (["decrease", "decline_tolerated"].includes(item.direction))
    return `Suporta até ${v4Quantity(Math.abs(percent))}% de queda no volume`;
  return "Sem condição de volume disponível";
};

export function v4ChosenComparison(suggestion) {
  if (suggestion?.status !== "ready") return null;
  const candidates = Array.isArray(suggestion.comparisons)
    ? suggestion.comparisons
    : [];
  if (suggestion.chosen_candidate_id) {
    return (
      candidates.find(
        item => item.candidate_id === suggestion.chosen_candidate_id
      ) || null
    );
  }
  if (suggestion.stance === "maintain")
    return (
      candidates.find(item => item.candidate_id === "maintain_catalog") || null
    );
  if (suggestion.stance !== "price_hypothesis") return null;
  const anchor = v4Number(suggestion.suggested_anchor_base_brl);
  if (anchor === null) return null;
  const matches = candidates.filter(item => {
    const price = v4Number(item.anchor_base_brl);
    return (
      item.eligible !== false &&
      price !== null &&
      Math.abs(price - anchor) < 0.00000001
    );
  });
  // Equal anchors need not identify the same vector. Only describe economics
  // when every matching alternative has the same supplied comparison values.
  const fields = [
    "contribution_brl",
    "delta_brl",
    "required_change_pct",
    "direction"
  ];
  return matches.length &&
    matches.every(item =>
      fields.every(field =>
        field === "direction"
          ? item[field] === matches[0][field]
          : v4Number(item[field]) === v4Number(matches[0][field])
      )
    )
    ? matches[0]
    : null;
}

// The original statement remains verbatim in the audit disclosure. Expand only
// internal labels here; this presentation adds no decision or evidence.
export const v4ReadableText = value =>
  typeof value === "string"
    ? value
        .replace(/\banchor_higher5\b/g, "referência 5% maior")
        .replace(/\banchor_lower5\b/g, "referência 5% menor")
        .replace(/\bmaintain_catalog\b/g, "preços atuais")
        .replace(/\bv3_registered\b/g, "sugestão V3")
        .replace(/\bv3_deterministic\b/g, "V3 pelas regras")
        .replace(/margem proxy/gi, "contribuição após CMC")
    : null;

export function v4MemorySummary(memory = {}) {
  const count = v4Number(memory.evidence_count);
  if (!count || count < 0)
    return "Esta rodada não contou com experiências anteriores na memória.";
  const records = `${v4Quantity(count)} ${
    count === 1 ? "registro anterior" : "registros anteriores"
  }`;
  if (memory.effect === "considered_no_choice_change")
    return `O V4 considerou ${records}, sem mudar a escolha.`;
  if (memory.effect === "caution_in_choice")
    return `O V4 declarou cautela na escolha ao considerar ${records}.`;
  return `${records} ${
    count === 1 ? "estava disponível" : "estavam disponíveis"
  } para consulta nesta rodada.`;
}
